// FileDropzone.tsx
import React from "react";
import { useDropzone } from "react-dropzone";
import './FileDropzone.css';

const DEFAULT_ACCEPT = {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
    'application/octet-stream': [],
} as const;

const DEFAULT_PLACEHOLDER = "Drag & drop an Excel file here, or click to select a file";

interface FileDropzoneProps {
    onDrop: (acceptedFiles: File[]) => void;
    selectedFile: File | null;
    isDragActive: boolean;
    /** When provided, overrides the default Excel accept (e.g. for CSV). */
    accept?: Record<string, string[]>;
    /** When provided, overrides the default placeholder text. */
    placeholderText?: string;
}

const FileDropzone: React.FC<FileDropzoneProps> = ({ onDrop, selectedFile, isDragActive, accept, placeholderText }) => {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: accept ?? DEFAULT_ACCEPT,
        maxFiles: 1,
    });

    const placeholder = placeholderText ?? DEFAULT_PLACEHOLDER;

    return (
        <div
            {...getRootProps({ className: `paint-dropzone ${isDragActive ? 'paint-dropzone-active' : ''}` })}
        >
            <input {...getInputProps()} />
            {isDragActive ? (
                <p className="paint-dropzone-text">Drop the file here...</p>
            ) : selectedFile ? (
                <div className="paint-file-details">
                    <p>Selected file:</p>
                    <p>{selectedFile.name}</p>
                </div>
            ) : (
                <p className="paint-dropzone-text">{placeholder}</p>
            )}
        </div>
    );
};

export default FileDropzone;
